import { useQuery } from '@tanstack/react-query';
import { getContactKundali } from '../api/contacts';

export function useContactKundali(id: string | null) {
  return useQuery({
    queryKey: ['contactKundali', id],
    queryFn: () => getContactKundali(id!),
    enabled: id != null && id !== '',
    staleTime: 30_000,
  });
}
